export default "__VITE_ASSET__Dv_H8Z4K__"